module.exports = __webpack_public_path__ + "img/straight_line_icon.8d5b6cc0.svg";